<script>
	import AboutBannerImg from '$lib/assets/images/about-banner.png';
	import MamunWithQueenImg from '$lib/assets/images/mamun-with-queen.png';
	import RobWithQueenImg from '$lib/assets/images/rob-with-queen.png';
	import TheTeamImg from '$lib/assets/images/the-team.jpg';
	import PageSeo from '$lib/components/PageSeo.svelte';
</script>

<svelte:head>
	<title>About London Tradition | British Fashion Heritage & Craftsmanship</title>
	<meta
		name="description"
		content="Learn about London Tradition's rich history, British fashion heritage, and exceptional craftsmanship. Explore our East London roots, our commitment to excellence, and meet our dedicated team of skilled professionals."
	/>
</svelte:head>

<PageSeo
	title="About London Tradition"
	description="Discover London Tradition's history, British fashion heritage, and craftsmanship. Explore East London roots, commitment to excellence, and our skilled team."
/>

<div class="banner">
	<img src={AboutBannerImg} alt="About Banner" />
	<h1>About</h1>
</div>

<div class="container">
	<h2>Our History</h2>

	<p>
		London Tradition began in East London in 2001 in the heart of the English garment manufacturing
		industry. Founded by Mamun Chowdhury and Rob Huson, with over fifty years between them in the
		garment business, London Tradition is all about British fashion heritage and exceptional quality
		craftsmanship. It’s that same unique London background that has influenced our emphasis on the
		tradition of British tailoring, taking heritage styles into the 21st century with cutting edge
		techniques and a modern fashion focus. London Tradition has always specialised in traditional
		British outerwear, not only for the iconic duffle coat for which they are best known, but in pea
		coats, trench coats, raincoats and quilted styles, all made to their exacting standards. It is
		this expert knowledge of British outerwear and their deep commitment to craftsmanship that has
		led to the global success of the London Tradition brand, rewarded in 2014 and 2020 with the
		Queens Award for International Trade.
	</p>
	<div class="founders">
		<img src={MamunWithQueenImg} alt="Co-founder Mamun with Queen Elizabeth II" />
		<img src={RobWithQueenImg} alt="Co-founder Rob with Queen Elizabeth II" />
	</div>
	<div class="heritage">
		<h2>Our Heritage</h2>
		<p>
			London Tradition is one of the leading manufacturers of British outerwear pieces. Using only
			the finest fabrics and accessories, our products have unique identity and character. It is
			this quest for artisanal materials and craftsmanship that makes us a leader in the market. Our
			products have a timeless style, combining modern details with classic design making each piece
			unique, understated and elegant. Our Duffle coats are iconic because of our innovative double
			face wool. The outside of our coats are clean and sharp but the inside boasts an interesting
			check pattern made from the same quality wool. This double-face fabric is perfectly suited to
			our iconic duffle and peacoat styles. There is no room for hiding and the interior of each
			coat clearly displays the craftsmanship that goes into each piece. The seams are boldly
			celebrated by highlighting them in different colours to the interior of each coat. This
			technique boasts the quality of our products and our commitment to excellence. Our distinctly
			East London location makes our brand the distinctive one that it is: calling on the heritage
			of British garment industry, we bring elements of London life into our clothes giving them
			their unique personality.
		</p>
	</div>
	<div class="team">
		<h2>Our Team</h2>
		<p>
			Our team is made up of dedicated professionals who are passionate about creating exceptional
			outerwear that reflects our heritage and commitment to quality. From our designers and pattern
			makers to our skilled craftsmen and women, everyone plays an important role in ensuring that
			our products are made to the highest standards. We believe that it is this attention to detail
			and unwavering commitment to excellence that sets us apart from our competitors.
		</p>
		<img src={TheTeamImg} alt="The Team" />
	</div>
</div>

<style lang="scss">
	.banner {
		position: relative;
		text-align: center;
		h1 {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			font-weight: bolder;
			color: white;
		}
		img {
			display: flex;
			width: 100%;
			height: 400px;
			object-fit: cover;
		}
	}

	.container {
		max-width: 800px;
		margin: 0 auto;
		padding: 40px;
		h2 {
			font-size: 24px;
			font-weight: bold;
			margin-bottom: 20px;
		}
		p {
			font-size: 16px;
			line-height: 1.5;
			color: #666;
		}
		.founders {
			display: flex;
			justify-content: center;
			img {
				margin: 10px;
			}
		}
		.team {
			margin: 0 auto;

			h2 {
				font-size: 24px;
				font-weight: bold;
				margin-bottom: 20px;
			}

			img {
				max-width: 100%;
				height: auto;
				margin-bottom: 20px;
			}

			p {
				font-size: 16px;
				line-height: 1.5;
				color: #666;
			}
		}
	}

	@media (max-width: 767px) {
		.founders {
			flex-direction: column;
			align-items: center;
			img {
				max-width: 100%;
			}
		}
	}
</style>
